import { Activity } from "lucide-react";

export default function Logo({ className = "", white = false }) {
  if (white) {
    return (
      <div className={`flex items-center gap-2 ${className}`}>
        <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-white/20 backdrop-blur-sm border border-white/40 shadow-sm">
          <Activity className="w-5 h-5 text-white stroke-[2.5px]" />
        </div>
        <span className="font-outfit font-black text-xl tracking-tight text-white shadow-sm">
          Monimek
        </span>
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-gradient-to-br from-[#0B3C5D] to-[#3FA7D6] shadow-[0_4px_12px_rgba(11,60,93,0.3)] border border-white/30">
        <Activity className="w-5 h-5 text-white stroke-[2.5px]" />
      </div>
      <span className="font-outfit font-black text-xl tracking-tight text-transparent bg-clip-text bg-gradient-to-r from-[#0B3C5D] to-[#3FA7D6]">
        Monimek
      </span>
    </div>
  );
}
